import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from "@/router/routes";
import store from '../store'
Vue.use(VueRouter)


const router = new VueRouter({
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = " ";
  }

  if (to.name !== 'Home' && store.state.user.token === ''&&to.name!=='Invition') {
    next({
      name: 'Home'
    })
  }
  store.dispatch('getSystemInfo').then(res=>{
    console.log('当前运行环境',res)
    next()
  },err=>{
    console.log('获取当前系统环境参数失败',err)
    next()
  }).catch(err=>{
    console.log('获取参数代码运行出错',err)
    next()
  })

  next()
})

export default router
